import apiClient, { publicApiClient } from "./api";

/**
 * Asset API services
 */

// Public endpoint: Get single asset (no auth required)
export const getAssetById = async (id) => {
  const response = await publicApiClient.get(`/assets/${id}`);
  return response.data;
};

// Protected: Get all assets
export const getAllAssets = async (params = {}) => {
  const response = await apiClient.get("/assets", { params });
  return response.data;
};

// Protected: Create asset
export const createAsset = async (assetData) => {
  const response = await apiClient.post("/assets", assetData);
  return response.data;
};

// Protected: Update asset
export const updateAsset = async (id, assetData) => {
  const response = await apiClient.put(`/assets/${id}`, assetData);
  return response.data;
};

// Protected: Delete asset
export const deleteAsset = async (id) => {
  const response = await apiClient.delete(`/assets/${id}`);
  return response.data;
};

// Protected: Get all asset types
export const getAllAssetTypes = async () => {
  const response = await apiClient.get("/asset-types");
  return response.data;
};

// Protected: Get single asset type
export const getAssetTypeById = async (id) => {
  const response = await apiClient.get(`/asset-types/${id}`);
  return response.data;
};

// Protected: Create asset type
export const createAssetType = async (typeData) => {
  const response = await apiClient.post("/asset-types", typeData);
  return response.data;
};

// Protected: Update asset type
export const updateAssetType = async (id, typeData) => {
  const response = await apiClient.put(`/asset-types/${id}`, typeData);
  return response.data;
};

// Protected: Delete asset type
export const deleteAssetType = async (id) => {
  const response = await apiClient.delete(`/asset-types/${id}`);
  return response.data;
};

// Protected: Get properties by asset type
export const getPropertiesByAssetType = async (assetTypeId) => {
  const response = await apiClient.get(`/properties/asset-type/${assetTypeId}`);
  return response.data;
};

// Public: Get properties by asset type (no auth, no redirect on 401)
export const getPublicPropertiesByAssetType = async (assetTypeId) => {
  const response = await publicApiClient.get(`/properties/asset-type/${assetTypeId}`);
  console.log("Public properties response:", response.body || response.data);
  return response.data;
};

// Protected: Create property definition
export const createPropertyDefinition = async (propertyData) => {
  const response = await apiClient.post("/properties", propertyData);
  return response.data;
};

// Protected: Update property definition
export const updatePropertyDefinition = async (id, propertyData) => {
  const response = await apiClient.put(`/properties/${id}`, propertyData);
  return response.data;
};

// Protected: Delete property definition
export const deletePropertyDefinition = async (id) => {
  const response = await apiClient.delete(`/properties/${id}`);
  return response.data;
};

// Protected: Bulk create assets from CSV
export const bulkCreateAssets = async (formData) => {
  const response = await apiClient.post("/assets/bulk-upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
